import { CmsObjectWithDefault } from '@components/Cms/types';

export type CNLoginFormCmsKey = 'SignInTitle' | 'SignInSubtitle' | 'SignInWithPhoneNumber';

export const CNLoginFormCmsWithDefault: CmsObjectWithDefault<CNLoginFormCmsKey> = {
    SignInTitle: {
        cmsId: 331871,
        defaultTranslation: 'Sign in or create an account',
    },
    SignInSubtitle: {
        cmsId: 331872,
        defaultTranslation: 'Sign up for free or log in to access amazing deals and benefits!',
    },
    SignInWithPhoneNumber: {
        cmsId: 558086,
        defaultTranslation: 'Sign in with phone number',
    },
};
